import { render, staticRenderFns } from "./CargoColegiadoShow.vue?vue&type=template&id=8f15a0fc&scoped=true&"
import script from "./CargoColegiadoShow.vue?vue&type=script&lang=js&"
export * from "./CargoColegiadoShow.vue?vue&type=script&lang=js&"
import style0 from "./CargoColegiadoShow.vue?vue&type=style&index=0&id=8f15a0fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f15a0fc",
  null
  
)

export default component.exports